import React from 'react';

/**
 * Delete item modal confirmation dialog
 * @param {function} onAccept confirm callback
 * @param {function} onCancel cancel callback
 */
var DeleteItemConfirmationDialog = React.createClass({

  propTypes: {
    onAccept: React.PropTypes.func,
    onCancel: React.PropTypes.func
  },

  render: function () {
    const {t} = this.props;

    return (
      <div className="btn-block">
        <button className="btn btn-danger" onClick={this.props.onAccept}>
          {t('Delete')}
        </button>
        <button className="btn btn-primary" onClick={this.props.onCancel}>
          {t('Cancel')}
        </button>
      </div>);
  }
});

exports.DeleteItemConfirmationDialog = ReactI18n.translate(['main'], {
  withRef: false,
  wait: true
})(DeleteItemConfirmationDialog);

/**
 * Simple modal
 * @param {function} onClose close modal callback
 */
exports.SimpleItemConfirmDialog = React.createClass({

  propTypes: {
    onClose: React.PropTypes.func
  },

  render: function () {
    return (
      <div className="btn-block">
        <button className="btn btn-primary" onClick={this.props.onClose}>Close
        </button>
      </div>);
  }
});


/**
 * Move/Copy confirmation dialog
 * @param {function} onCopy
 * @param {function} onMove
 */
exports.MoveCopyDialog = React.createClass({

  propTypes: {
    onCopy: React.PropTypes.func,
    onMove: React.PropTypes.func,
    onCancel: React.PropTypes.func
  },

  render(){
    return (
      <div className="btn-block">
        { this.props.onCopy ?
          <button className="btn btn-primary" onClick={this.props.onCopy}>
            Copy</button>
          : "" }
        { this.props.onMove ?
          <button className="btn btn-primary" onClick={this.props.onMove}>
            Move</button>
          : "" }
        { !this.props.onMove || !this.props.onCopy
          ? <button className="btn btn-primary" onClick={this.props.onCancel}>
          Cancel</button>
          : ""}
      </div>
    )
  }
});
